import type { JSX } from "react";
import { RestError } from "../../services/rest-service/RestService";

export enum AppNotificationTypeEnum {
    Info = 1,
    Warning = 2,
    Error = 3,
    Success = 4
}

export type AppNotificationState = {
    notificationType: AppNotificationTypeEnum;
    title?: string | undefined | null;
    message?: string | JSX.Element | undefined | null;
    show: boolean;
    hideContactInfo?: boolean | undefined;
    error?: RestError | undefined;
    showDetails?: boolean | undefined;
};
